import { useState } from 'react';
import { FormGroup } from 'reactstrap';

interface RowData {
  value: string;
  label: string;
}

interface RadioBasedButtonProps {
  contentJSON: RowData[];
}

const RadioBasedButton = ({ contentJSON }: RadioBasedButtonProps) => {
  const [selected, setSelected] = useState('Active');

  const handleSelection = (value: string) => {
    setSelected(value);
  };

  return (
    <>
      <div className="button-radio-group">
        {contentJSON.map((row: RowData) => (
          <FormGroup check key={row.value}>
            <button
              type="button"
              className={`radio-button ${
                selected === row.value ? 'selected' : ''
              }`}
              onClick={() => handleSelection(row.value)}
            >
              {row.label}
            </button>
          </FormGroup>
        ))}
      </div>
    </>
  );
};

export default RadioBasedButton;
